@let fields = rendering().fields;
<wl-footer
  [appNavigation]="{
    title: fields?.appButtonsTitle?.value || 'Ontdek onze app',
    items: [
      {
        alt: 'Download de app op Google Play!',
        type: 'google-play-store',
        src: 'assets/images/app-button-android.svg' | deployUrl,
        url: fields?.appButtonsAndroidLink?.value?.href ?? '/',
      },
      {
        alt: 'Download de app in de App Store!',
        type: 'ios-app-store',
        src: 'assets/images/app-button-ios.svg' | deployUrl,
        url: fields?.appButtonsIosLink?.value?.href ?? '/',
      },
    ],
  }"
  [webNavigation]="webNavigation()"
  [usefulLinks]="usefulLinks()"
  [logo]="{
    url: basePath,
    label: logoLabel,
    height: logoSizing.height,
    width: logoSizing.width,
  }"
  [currentYear]="currentYear"
  [brandName]="brandName"
/>
